require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-articles-financial-centers-ceo-inducted-into-indiana-credit-union-hall-of-fame.json") })
        }
      }, "path---es-articles-financial-centers-ceo-inducted-into-indiana-credit-union-hall-of-fame");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-articles-financial-centers-ceo-inducted-into-indiana-credit-union-hall-of-fame!./.cache/json/es-articles-financial-centers-ceo-inducted-into-indiana-credit-union-hall-of-fame.json
// module id = 2193
// module chunks = 231608221292675